<template>
    <div v-if="params && params.isActive">
        <ModalDefault @close="close();" :loading="loading">
            <template slot="main">
                <div class="d-flex justify-content-center container flex-column">
                    <p class="modal-title">{{ $t("common.remove") }}</p>
                    <p
                        v-html-safe="
                            $t('zoneGroups.deleteFromBrand', {
                                group: params.brandHasZoneGroup.zoneGroups.name.toUpperCase(),
                                brand: params.brandHasZoneGroup.brand.name.toUpperCase()
                            })
                        "
                    ></p>

                    <div class="d-flex justify-content-end mt-4">
                        <ClientColorButton :background-color="currentBrand.linksColor" @click="removeZoneGroups();" class="mr-3">
                            {{ $t("common.remove") }}
                        </ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="close();">{{ $t("actions.cancel") }}</ClientColorButton>
                    </div>
                </div>
            </template>
        </ModalDefault>
    </div>
</template>

<script>
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import TextareaInputBloc from "@/components/ui/Form/TextareaInputBloc";
import zoneGroupService from "@/services/zoneGroup";
import historyService from "@/services/history";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import DefaultTextInputBloc from "@/components/ui/Form/DefaultTextInputBloc";
import { mapState } from "vuex";

export default {
    name: "delete-zone-groups",
    data() {
        return {
            zoneGroupName: null,
            forRight: false,
            forDashboard: false,
            loading: false
        };
    },
    components: {
        DefaultTextInputBloc,
        DefaultTextareaInputBloc,
        ModalDefault,
        ModalTheme,
        TextInputBloc,
        TextareaInputBloc
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    watch: {},
    mounted() {},
    methods: {
        close() {
            this.params.isActive = false;
        },
        removeZoneGroups() {
            try {
                this.loading = true;
                zoneGroupService
                    .delete(this.params.brandHasZoneGroup.zoneGroups.id)
                    .then(() => {
                        this.loading = false;
                        this.dialogSuccess("success");
                        this.$emit("success");
                        this.close();
                    })
                    .catch(() => {
                        this.loading = false;
                        this.dialogError("error");
                    });
            } catch (e) {
                this.dialogError("error");
            }
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"])
    }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// DeleteZoneGroups.vue?da5dc824